import * as renderers from '../utils/columnRenderers';

const columns = [
  {
    title: 'id',
    dataIndex: 'id',
    key: 'id',
    align: "center",
    width: 70,
    render: 'renderEmployeeId'
  },
  {
    title: 'Сотрудник',
    dataIndex: 'name',
    key: 'name',
    align: "center",
    ellipsis: true,
    // width: 70,
  },
  {
    title: 'Телефон',
    dataIndex: 'phone',
    key: 'phone',
    align: "center",
    // width: 70,
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    align: "center",
    // width: 70,
  },
  {
    title: 'Дата добавления',
    dataIndex: 'addedTime',
    key: 'addedTime',
    align: "center",
    // width: 70,
    // render:'renderEmployeesNumber'
  },
]

export default function getEmployeesColumns() {
  return columns.map(column => {
    if(typeof column.render === 'string') {
      return {
        ...column,
        render: renderers[column.render]
      }
    }
    return {...column}
  })
}